import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withDialogs from 'shared/hocs/withDialogs';
import { toLocalized } from 'shared/helpers/locale';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import { AutobookingAdvert } from 'shared/components/AutobookingForm';
import withTransportInfo from 'shared/hocs/withTransportInfo/withTransportInfo';
import AdvertLeasingTitle from 'desktop/components/AdvertLeasingTitle/AdvertLeasingTitle';
import VideoBlock from 'desktop/components/NewsBlock/VideoBlock';
import { getVideoById } from 'shared/actions/journal';
import AdvertDescription from 'shared/components/AdvertDescription/AdvertDescription';
import AdvertOptions from 'desktop/components/AdvertOptions/AdvertOptions';
import AdvertMessage from 'shared/components/AdvertMessage/AdvertMessage';
import AdvertInfo from 'desktop/components/AdvertInfo/AdvertInfo';
import AdvertSeller from 'desktop/components/AdvertSeller/AdvertSeller';
import AdvertSellerDealer from 'desktop/components/AdvertSeller/AdvertSellerDealer';
import AdvertPhotos from 'desktop/components/AdvertPhotos/AdvertPhotos';
// import LeasingForm from 'shared/components/LeasingAndVin/LeasingForm';
import { ACTIVE_STATUSES } from 'shared/constants/adverts';
import { generateSparesSearchUrl, generateJournalhUrl } from 'shared/helpers/urls';
import YoutubeVideo from 'shared/components/YoutubeVideo/YoutubeVideo';
import { getAdvertStatuses } from 'shared/helpers/transportInfo';
import { injectIntl, FormattedMessage, intlShape } from 'react-intl';
// import DialogForm from 'shared/components/DialogForm/DialogForm';
import LeasingQuestions from 'shared/components/LeasingOnlineBanner/LeasingQuestions/LeasingQuestions';
import { isAnyLeasingAvailable } from 'shared/helpers/leasing/leasing';

// import SparesForAdvert from '../SparesForAdvert/SparesForAdvert';
import TestDrives from '../TestDrives/TestDrives';
import history from '../../../../../history';
import Warranty from '../Warranty/Warranty';
import Nav from '../Nav/Nav';
import s from './CarInfo.css';

const TABS = {
  ADVERT: 'advert',
  TEST_DRIVES: 'test-drives',
};

class CarInfo extends React.Component {
  static propTypes = {
    carInfo: PropTypes.shape().isRequired,
    selVideoParams: PropTypes.shape(),
    style: PropTypes.shape(),
    count: PropTypes.number,
    spares: PropTypes.arrayOf(PropTypes.shape()),
    videosAboutCar: PropTypes.arrayOf(PropTypes.shape()),
    getSelVideo: PropTypes.func.isRequired,
    isApprovePub: PropTypes.bool.isRequired,
    handleSendMessage: PropTypes.func.isRequired,
    user: PropTypes.shape().isRequired,
    leasingParams: PropTypes.shape(),
    //
    transformedData: PropTypes.shape().isRequired,
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    selVideoParams: null,
    style: null,
    count: null,
    spares: [],
    videosAboutCar: [],
    leasingParams: null,
  };

  state = {
    activeTab: TABS.ADVERT,
  };

  handleTabChange = tabSlug => {
    this.setState({ activeTab: tabSlug });
  };

  handleShowVideo = (videoParams = null) => {
    const { carInfo, intl: { locale }, getSelVideo, selVideoParams } = this.props;
    const pathname = generateJournalhUrl({ ...carInfo, location }, location && location.is_country);

    if (videoParams) {
      getSelVideo(videoParams);
    } else if (selVideoParams) {
      getSelVideo();
    }
    history.push(toLocalized(`/${pathname}/`.replace(/\/\//g, '/'), locale));
  };

  render() {
    const {
      carInfo,
      style,
      count,
      spares,
      transformedData,
      videosAboutCar,
      isApprovePub,
      handleSendMessage,
      user,
      intl,
      leasingParams,
    } = this.props;

    const {
      id,
      make,
      active,
      model,
      modification,
      year,
      transport,
      date_created: dateCreated,
      date_publicated: datePublicated,
      hot_date: hotDate,
      photos,
      description,
      options,
      author,
      sold,
      clarify_price_link: clarifyPriceLink,
      is_negotiable_price: isNegotiablePrice,
      contact_name: contactName,
    } = carInfo;
    const isDealer = Boolean(carInfo.agency && carInfo.agency.id);
    const statuses = getAdvertStatuses(carInfo, intl);
    const {
      warranty,
      priceList,
      title,
      seoTitle,
      alt,
      agency,
      defaultImage,
      infoList,
      authorName,
      sellerExtraText,
      sellerLink,
      sellerLocation,
    } = transformedData;

    const sparesLink = `/${generateSparesSearchUrl({
      transport,
      make,
      model,
    })}`;
    const isActive = active === ACTIVE_STATUSES.ACTIVE || isApprovePub;
    const tabs = [
      {
        title: 'Объявление',
        slug: TABS.ADVERT,
      },
      {
        title: 'Тест-драйвы',
        slug: TABS.TEST_DRIVES,
        disabled: transport.slug !== 'avto',
      },
      {
        title: 'Запчасти',
        href: sparesLink,
      },
    ];
    const { activeTab } = this.state;
    const isLeasing = isAnyLeasingAvailable(carInfo);
    const AdvertSellerComponent = isDealer ? AdvertSellerDealer : AdvertSeller;
    return (
      <div className={s.root} style={style}>
        <Nav tabs={tabs} onTabChange={this.handleTabChange} activeTabSlug={activeTab} />

        {activeTab === TABS.ADVERT &&
          <div>
            <AdvertLeasingTitle
              id={id}
              views={count}
              title={title}
              seoTitle={seoTitle}
              prices={priceList}
              dateCreated={hotDate || datePublicated || dateCreated}
              clarifyPriceLink={clarifyPriceLink}
              isNegotiablePrice={isNegotiablePrice}
              advert={carInfo}
              leasingParams={leasingParams}
            />
            <div className={s.infoBlock}>
              <div className={s.divider} />
            </div>
            {warranty && warranty.title && <Warranty warranty={warranty} />}
            <div className={s.flexRow}>
              <div className={s.left}>
                <AdvertInfo infoList={infoList} advert={carInfo} />
              </div>
              <div className={s.right}>
                {/* <LeasingForm advert={carInfo} upperBlock /> */}
                <AdvertPhotos photos={isActive ? photos : []} defaultImg={defaultImage} alt={alt} />
                <YoutubeVideo link={carInfo.video} className={s.youtubeVideo} />
              </div>
            </div>
            <div className={s.infoBlock}>
              <AdvertSellerComponent
                key={id}
                title={title}
                prices={priceList}
                advert={carInfo}
                advertID={id}
                agency={agency}
                avatar={agency ? agency.logo : ''}
                authorName={contactName || authorName}
                authorID={author.id}
                location={sellerLocation}
                link={sellerLink}
                extraText={sellerExtraText}
                sold={sold}
                transport={transport}
                active={active}
                isApprovePub={isApprovePub}
              />
            </div>

            <div className={s.infoBlock}>
              <AdvertDescription
                title={title}
                statuses={statuses}
                description={description}
                options={options}
                isDealer={isDealer}
                advert={carInfo}
              />
              {isLeasing && leasingParams && leasingParams.monthlyPayment
                ? <LeasingQuestions advert={carInfo} leasingParams={leasingParams} />
                : null}
            </div>
            <div className={s.infoBlock}>
              <div className={s.divider} />
            </div>
            <div className={s.infoBlock}>
              <AdvertOptions options={options} title={title} />
              {videosAboutCar &&
                videosAboutCar.length > 0 &&
                <VideoBlock
                  maxMobileWidth={380}
                  columns={2}
                  handleShowVideo={this.handleShowVideo}
                  news={videosAboutCar.slice(0, 2)}
                  title={intl.formatMessage({ id: 'Видео о модели' })}
                >
                  {videosAboutCar.length > 2 &&
                    <div className={s.allVideos} onClick={() => this.handleShowVideo()}>
                      <FormattedMessage id={'Все видео'} />
                    </div>}
                </VideoBlock>}
            </div>
            <div className={s.infoBlock}>
              <div className={s.divider} />
            </div>
            <div className={s.infoBlock}>
              <AdvertMessage carInfo={carInfo} user={user} handleSendMessage={handleSendMessage} />
            </div>
          </div>}

        {activeTab === TABS.TEST_DRIVES &&
          <TestDrives
            make={make.id || undefined}
            model={model.id || undefined}
            generation={modification.generation.id || undefined}
            year={year || undefined}
          />}
      </div>
    );
  }
}

const mapDispatchToProps = {
  getSelVideo: getVideoById,
};

const mapStateToProps = state => ({
  selVideoParams: state.globals.journal.selVideoParams,
});

export default withTransportInfo(
  withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(injectIntl(withDialogs(CarInfo)))),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/advert/components/CarInfo/CarInfo.js